import { Component, OnInit } from '@angular/core';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {Page} from '../../../shared/models/page.interface';
import {MessageService} from '../../../shared/services/message.service';
import {Router} from '@angular/router';
import {FormsService} from '../../../intelligence-data-entry/services/forms.service';
import {FormsAdmin} from '../../models/forms.interface';
import {FormsAdminSearch} from '../../models/forms-search.interface';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss']
})
export class FormsComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  forms!: Page<FormsAdmin>;
  search: FormsAdminSearch = {};
  private page: PageRequest = {page: 0, size: 100, sort: 'year', direction: 'desc'};
  constructor(private readonly formsService: FormsService,
              private messageService: MessageService,
              readonly router: Router) { }

  ngOnInit(): void {
    this.updateData();
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadForms(event: PageRequest): void {
    this.page = event;
    this.updateData();
  }

  searchForms(search: FormsAdminSearch): void {
    this.search = search;
    if (Object.keys(search).length === 0 && this.search !== {}) {
      this.page = {page: 0, size: 100, sort: 'year', direction: 'asc'};
    }
    this.updateData();
  }

  private updateData(): void {
    this.formsService.getAllAnswerForms(this.search, this.page).subscribe(
      data => this.forms = data
    );
  }


}
